import { Canvas as Ripple } from './ripple.js'

export class TeasNiuNiu {
  constructor() {
    this.globalContext = null
    this.$label = ''
    this.$message = ''
    this.init()
    this.newShortSpeechRecognition()
    this.shortSpeechRecognitionClosed()
  }
  get isShow() {
    return this?.box?.classList?.contains('show')
  }
  set isShow(value) {
    if (value) {
      !this.isShow && this?.box?.classList?.add('show')
    } else {
      this.isShow && this?.box?.classList?.remove('show')
    }
  }
  set label(value) {
    this.$label = value
    let labelDom = this.box?.querySelector('.dsf-teas-mobile-voice-wake-up-label');
    if (labelDom) {
      labelDom.innerText = value
    }
  }
  set message(value) {
    this.$message = value
    let labelDom = this.box?.querySelector('.dsf-teas-mobile-voice-wake-up-message');
    if (labelDom) {
      labelDom.innerText = value
    }
  }
  get context() {
    return this.$context || this.globalContext || null
  }
  init() {
    this.box = document.createElement('div');
    this.box.setAttribute('class', 'dsf-control dsf-teas-mobile-voice-wake-up mobile')
    this.box.innerHTML = `
      <div class="dsf-teas-mobile-voice-wake-up-header">
        <div>
          牛牛正在听
        </div>
        <div class="dsf-teas-mobile-voice-wake-up-close">X</div>
      </div>
      <div class="dsf-teas-mobile-voice-wake-up-main">
        <div class="dsf-teas-mobile-voice-wake-up-label"></div>
        <div class="dsf-teas-mobile-voice-wake-up-message"></div>
      </div>
      <div class="dsf-teas-mobile-voice-wake-up-line">
      </div>
  `
    document.body.appendChild(this.box)
    this.box.querySelector('.dsf-teas-mobile-voice-wake-up-close').onclick = () => {
      this.close()
    }
    let lineDom = this.box.querySelector('.dsf-teas-mobile-voice-wake-up-line')
    let width = this.box.offsetWidth
    let height = lineDom.offsetHeight
    this.ripple = new Ripple(lineDom, width, height)
  }
  open(context) {
    this.label = '你可以这样说：'
    this.message = '打开一周课表'
    this.isShow = true
    this.startRead('你好，请说', () => {
      this.stopHear()
      this.stratHear()
      this.$context = context
    });
  }
  close(msg) {
    if (msg) this.startRead(msg)
    this.$context = null
    this.ripple?.stop()
    this.isShow = false
    this.stopHear()
  }
  newShortSpeechRecognition() {
    dsf?.driver?.$event.on(dsf?.driver?._onEventMappingNames.NEW_SHORT_SPEECH_RECOGNITION, ({ args }) => {
      if (this.isShow && this.$label !== '你正在说：') {
        this.label = '你正在说：'
        this.message = ''
        this.$typing = this.$message
        this.ripple?.init()
        this.ripple?.start()
      }
      this.$typing += args
      this.typingMessage()
    })
  }
  typingMessage() {
    this.message = this.$typing
  }
  shortSpeechRecognitionClosed() {
    dsf?.driver?.$event.on(dsf?.driver?._onEventMappingNames.SHORT_SPEECH_RECOGNITION_CLOSED, ({ args }) => {
      let { $message } = this
      if (this.isShow) {
        setTimeout(() => {
          if ($message.trim()) {
            this.ripple?.loading()
            this.startRead('收到，正在处理中...')
            this.getCommand($message.trim())
          } else {
            this.close('没有听到你在说话呢')
          }
        }, 1000)
      }
    })
  }
  startRead(msg, cb) {
    dsf?.driver?.$event.on(dsf?.driver?._onEventMappingNames.READ_TEXT_COMPLETED, ({ args }) => {
      cb && cb()
    }, true)
    dsf?.driver?.recording?.startTts({ message: msg })
  }
  stratHear() {
    dsf?.driver?.openShortSpeechRecognition()
  }
  stopHear() {
    dsf?.driver?.closeShortSpeechRecognition()
  }
  // 获取指令
  getCommand(keyword) {
    if (!keyword || !this.isShow) return
    dsf.http.get('/teas/voice/getCommand', {
      keyword
    }).then(({ data }) => {
      console.log(data)
      if (data && data.success) {
        this.execCommand(data.data)
      } else {
        this.close(data.message)
      }
    }).catch((e) => {
      this.close('我没明白呢')
    })
  }
  // 执行命令
  execCommand(opt) {
    if (!opt) return;
    switch (opt.moduleActionValue.toString()) {
      case "1":
        this?.context?.$open({
          url: opt.command
        })
        this.close(`已帮你打开${opt.infoName}`)
        break
      case "3":
        if (opt.command) {
          window.open(`tel:${opt.command}`)
          this.close()
        } else {
          this.close('没有查到呢，无法拨打')
        }
        break
    }
  }

  // 打开唤醒
  wakeStart() {
    dsf?.driver?.recording?.wakeStart()
  }

  // 关闭唤醒
  wakeStop() {
    dsf?.driver?.recording?.wakeStop()
  }
}




// 语音唤醒
export default {
  install(Vue, opt = {}) {
    opt = {
      command: 'mobileVoiceWakeUp',
      class: TeasNiuNiu,
      ...opt
    }
    if ($$serverConfig.setting_teas_isvoice != 1) return;
    const voiceWake = new opt.class(Vue)
    Vue.prototype.$voiceWake = voiceWake;
    Vue.directive(opt.command, {
      bind: (el, binding, vnode, oldVnode) => {
        el.onclick = () => {
          voiceWake.open(vnode.context)
        }
      },
      componentUpdated: () => {
        // console.log("componentUpdated")
      },
      inserted: () => {
        // console.log("inserted")
      },
      update: () => {
        // console.log("update")
      },
      unbind: () => {
        // console.log("unbind")
        uninit()
      }
    })
  }
}